<template>
  <div class="area-with-units" v-if="size">
    <span v-if="!unit || unit === 'm2'">
      {{ $filters.number(size) }}
      m<sup>2</sup>
    </span>
    <span v-else>
      {{ $filters.number(size / 10000, 1) }}
      {{ unit }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'area-with-units',
  props: {
    size: {
      type: Number,
      required: true,
    },
    unit: {
      type: String,
      required: false,
    },
  },
};
</script>
